(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-maison-product-slider]').forEach((section) => {
      if (section.dataset.maisonSliderReady === 'true') return;
      section.dataset.maisonSliderReady = 'true';
      const track = section.querySelector('[data-maison-product-track]');
      if (!track) return;
      section.querySelectorAll('[data-maison-product-dir]').forEach((button) => {
        button.addEventListener('click', () => {
          const dir = Number(button.dataset.maisonProductDir || 1);
          const first = track.firstElementChild;
          const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
          const step = first ? first.getBoundingClientRect().width + gap : track.clientWidth * .8;
          track.scrollBy({ left: dir * step, behavior: 'smooth' });
        });
      });
    });
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
